// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n* {\r\n  font-family: Avenir, Helvetica, Arial, sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  margin: 0;\r\n  padding: 0;\n}\nbody {\r\n  background: #f3f3f3;\r\n  color: #2c3e50;\n}\nli {\r\n  list-style: none;\n}\na {\r\n  text-decoration: none;\n}\r\n", ""]);
// Exports
module.exports = exports;
